// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"BrandModalComponent_modalBody__20hZX","searchParams":"BrandModalComponent_searchParams__11lE8","modalFooter":"BrandModalComponent_modalFooter__3eMRV"};